import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker, registerLaunchQueueConsumer } from "@/lib/pwa";

// Register the PWA service worker so Chrome/Edge offer "Install" + so the OS
// can register OpenCSV as a CSV file handler. Also subscribe to the File
// Handler API's launch queue (desktop "Open with → OpenCSV" handoff).
registerServiceWorker();
registerLaunchQueueConsumer();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
